import { Component } from '@angular/core';

@Component({
  selector: 'bottom-curve',
  template: `
    <div class="bottom-curve">
        <svg id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1920 80">
        <path class="st0 index-last-wave"
                d="M948.5,65.3C628.9,64.8,310.5,42.9,0,0V161H1920V0C1602,43.9,1275.8,65.8,948.5,65.3Z" />
        </svg>
    </div>
  `,
  styleUrls: ['bottom-curve.less']
})
export class BottomCurveComponent {}
